import React from 'react'

const AccountTypeToggle = ({ value, onChange }) => (
  <div className="flex rounded-lg border border-gray-200 bg-gray-50 p-1">
    <button
      type="button"
      onClick={() => onChange('EMPLOYER')}
      className={`flex-1 rounded-md px-3 py-2 text-sm font-medium transition-colors ${
        value === 'EMPLOYER'
          ? 'bg-white text-gray-900 shadow-sm'
          : 'text-gray-500 hover:text-gray-700'
      }`}
    >
      Employer
    </button>
    <button
      type="button"
      onClick={() => onChange('JOB_SEEKER')}
      className={`flex-1 rounded-md px-3 py-2 text-sm font-medium transition-colors ${
        value === 'JOB_SEEKER'
          ? 'bg-white text-gray-900 shadow-sm'
          : 'text-gray-500 hover:text-gray-700'
      }`}
    >
      Job seeker
    </button>
  </div>
)

export default AccountTypeToggle
